import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';
import StarRating from '../StarRating/StarRating'; // You'll need to create this component
import './Testmonies.css';

function Testmonies({ text, name, title, image, rating = 5 }) {
  return (
    <article className="testimonial-card">
      <div className="testimonial-quote">
        <FaQuoteLeft className="quote-icon" />
        <p className="testimonial-text">{text}</p>
      </div>
      
      <div className="testimonial-author">
        <div className="author-image-container">
          <img 
            src={image} 
            alt={`${name}, ${title}`} 
            className="author-image"
            loading="lazy"
          />
        </div>
        <div className="author-info">
          <h4 className="author-name">{name}</h4>
          <p className="author-title">{title}</p>
          <StarRating rating={rating} />
        </div>
      </div>
    </article>
  );
}

export default Testmonies;